import { React, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';
import Lottie from 'lottie-react';

// Model //
import FetchModule from '../../../../Share/Network/FetchModule';
// Model //

// Component //
import RefundReasonInput from '../../../../../Component/MemberComponent/MemberDetail/NewRefundReasonInput';
import CalenderInput from '../../../../../Component/LockerComponent/LockerCalenderInput';
import PaymentOptionCustomInput from '../../../../../MemberRegistration/Component/PaymentOptionCustomInput';
import PaymentOptionSettingSelectBox from '../../../../../MemberRegistration/Model/PaymentOptionSettingSelectBox';
import AddPaymentOptionModal from '../../../../../MemberRegistration/Model/AddPaymentOptionModal';
// Component //

// Icon //
import { ReactComponent as TrashIcon } from '../../../../../image/Trash.svg';
// Icon //

// Animation //
import LoadingAnimation from '../../../../../Animation/NewLoading.json';
// Animation //

// Image //
import RefundIcon from '../../../../../image/RefundIcon.png';
// Image //

import TotalModalWrapper from '../../../../Share/Normal/TotalModalWrapper';
import { useLanguage } from '../../../../../Context/LanguageContext';
import { useTheme } from '../../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../../Styles/theme';

export default function RefundModal(props) {
  const { memberName, storeName, rendering, exitClick, refundData } = props;

  const history = useHistory();
  const { t, isEng } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isCompleteSettlement, setIsCompleteSettlement] = useState(false);
  const [paymentOptions, setPaymentOptions] = useState([{ id: 0, name: '현금' }, { id: 0, name: '카드' }]);
  const [selectedPaymentOptions, setSelectedPaymentOptions] = useState([{ id: 0, name: '현금', price: 0 }]);
  const [isClickedAddPaymentOption, setIsClickedAddPaymentOption] = useState(false);
  const [approvalDate, setApprovalDate] = useState(moment());
  const [reason, setReason] = useState('');

  const [isViewSelectModal, setIsViewSelectModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(t('memberDetail.refundModal.refundInProgress'));

  // 센터 환불인지 링크 환불인지 여부 //
  const [isCenterRefund, setIsCenterRefund] = useState(true);

  const isLinkPayPaid = !isCenterRefund;

  // 이전 환불 신청이 있는지 확인 및 세팅 //
  useEffect(() => {
    const hasLinkoPay = refundData.selectedPaymentOptions &&
      refundData.selectedPaymentOptions.some(opt => opt.name === '링코페이');

    const isLink = refundData.merchantUid.split('-')[2] !== '3' || hasLinkoPay;
    if (isLink) setIsCenterRefund(false);
    else setIsCenterRefund(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('sales/refund/state/' + refundData.merchantUid, 'GET');
        if (responseData.status === 200) {
          setIsCompleteSettlement(responseData.data.completeSettlement);
          const opts = [];
          if (responseData.data.cardPrice > 0) opts.push({ id: 0, name: '카드', price: responseData.data.cardPrice });
          if (responseData.data.cashPrice > 0) opts.push({ id: 0, name: '현금', price: responseData.data.cashPrice });
          setSelectedPaymentOptions(opts.length > 0 ? opts : [{ id: 0, name: isLink ? '링코페이' : '현금', price: 0 }]);
          setApprovalDate(moment(responseData.data.approvalDate));
          setReason(responseData.data.reason);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }, [history, refundData])

  // 결제수단 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('payment_option/', 'GET');
        if (responseData.status === 200) {
          setPaymentOptions([{ id: 0, name: '현금' }, { id: 0, name: '카드' }].concat(responseData.data.paymentOptions));
        }
      }
    )();
  }, [])

  // 로딩 텍스트 변경 //
  useEffect(() => {
    if (!isLoading) return;

    setTimeout(() => {
      if (loadingText === t('memberDetail.refundModal.refundInProgress')) setLoadingText(t('memberDetail.refundModal.refundInProgress') + '.');
      else if (loadingText === t('memberDetail.refundModal.refundInProgress') + '.') setLoadingText(t('memberDetail.refundModal.refundInProgress') + '..');
      else if (loadingText === t('memberDetail.refundModal.refundInProgress') + '..') setLoadingText(t('memberDetail.refundModal.refundInProgress') + '...');
      else if (loadingText === t('memberDetail.refundModal.refundInProgress') + '...') setLoadingText(t('memberDetail.refundModal.refundInProgress'));
    }, 800);
  }, [isLoading, loadingText])

  // 결제 수단 이름 다국어 변환 //
  function getPaymentName(name) {
    const map = {
      '카드': t('memberDetail.refundModal.card'),
      '현금': t('memberDetail.refundModal.cash'),
      '링코페이': t('memberDetail.refundModal.linkoPay'),
    };
    return map[name] ?? name;
  }

  // selectedPaymentOptions에서 cardPrice/cashPrice 계산 //
  function computePrices() {
    let cardPrice = 0;
    let cashPrice = 0;
    for (const opt of selectedPaymentOptions) {
      const price = parseInt(String(opt.price).replaceAll(',', '')) || 0;
      if (opt.name === '카드' || opt.name === '링코페이') cardPrice += price;
      else cashPrice += price;
    }
    return { cardPrice, cashPrice };
  }

  // 환불버튼 클릭시 //
  function onClickRefund() {

    if (!isCenterRefund) {
      const total = selectedPaymentOptions.reduce((sum, opt) => sum + (parseInt(String(opt.price).replaceAll(',', '')) || 0), 0);
      if (total === 0) {
        alert(t('memberDetail.refundModal.alertEnterRefundAmount'));
        return;
      }

      // 정산일 이후 결제된 내역인경우 카드 취소 //
      // if (moment().startOf('month').isBefore(moment(refundData.approvalDate))) {
      if (!isCompleteSettlement) {
        const { cardPrice, cashPrice } = computePrices();
        let requestData = {
          merchantUid: refundData.merchantUid,
          cardPrice: cardPrice,
          cashPrice: cashPrice,
          reason: reason,
        }
        setIsLoading(true);

        const fetchModule = new FetchModule();
        (
          async () => {
            const responseData = await fetchModule.postDataVersion2('sales/refund/linkpay', 'POST', requestData);

            if (responseData.status === 200) {
              setIsLoading(false);
              rendering();
              exitClick();
            }
            else if (responseData.status === 201) {
              alert(t('memberDetail.refundModal.alertInvalidRequest'));
              setIsLoading(false);
              return;
            }
            else if (responseData.status === 202) {
              alert(t('memberDetail.refundModal.alertNotCompletedPayment'));
              setIsLoading(false);
              return;
            }
            else if (responseData.status === 203) {
              alert(t('memberDetail.refundModal.alertNotLinkpayPayment'));
              setIsLoading(false);
              return;
            }
            else if (responseData.status === 204) {
              alert(t('memberDetail.refundModal.alertPaymentDataNotFound'));
              setIsLoading(false);
              return;
            }
            else if (responseData.status === 205) {
              alert(t('memberDetail.refundModal.alertAlreadyRefunded'));
              setIsLoading(false);
              return;
            }
            else if (responseData.status === 206) {
              alert(t('memberDetail.refundModal.alertRefundExceeded'));
              setIsLoading(false);
              return;
            }
            else if (responseData.status === 401) history.push('/');
            else {
              alert(responseData.error);
              setIsLoading(false);
              return;
            }
          }
        )();
      }
      // 정산일 이후의 경우 환불내역 생성전 안내문구 띄우기 //
      else {
        setIsViewSelectModal(true);
      }
    }
    else {
      const total = selectedPaymentOptions.reduce((sum, opt) => sum + (parseInt(String(opt.price).replaceAll(',', '')) || 0), 0);
      if (total === 0) {
        alert(t('memberDetail.refundModal.alertEnterRefundAmount'));
        return;
      }

      const { cardPrice, cashPrice } = computePrices();
      let requestData = {
        merchantUid: refundData.merchantUid,
        cardPrice: cardPrice,
        cashPrice: cashPrice,
        reason: reason,
        approvalDate: approvalDate.format('YYYY-MM-DDTHH:mm:ss')
      }
      setIsLoading(true);

      const fetchModule = new FetchModule();
      (
        async () => {
          const responseData = await fetchModule.postDataVersion2('sales/refund/center', 'POST', requestData);

          if (responseData.status === 200) {
            rendering();
            exitClick();
            setIsLoading(false);
          }
          else if (responseData.status === 204) {
            alert(t('memberDetail.refundModal.alertRefundExceeded'));
            setIsLoading(false);
          }
          else if (responseData.status === 401) history.push('/');
        }
      )();
    }
  }

  // 정산일 이전 데이터 확인모달에서 환불버튼 클릭시 //
  function onClickRefundOnCheckModal() {
    const { cardPrice, cashPrice } = computePrices();
    let requestData = {
      merchantUid: refundData.merchantUid,
      cardPrice: cardPrice,
      cashPrice: cashPrice,
      reason: reason,
    }
    setIsLoading(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('sales/refund/linkpay', 'POST', requestData);

        if (responseData.status === 200) {
          setIsLoading(false);
          rendering();
          exitClick();
        }
        else if (responseData.status === 201) {
          alert(t('memberDetail.refundModal.alertInvalidRequest'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 202) {
          alert(t('memberDetail.refundModal.alertNotCompletedPayment'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 203) {
          alert(t('memberDetail.refundModal.alertNotLinkpayPayment'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 204) {
          alert(t('memberDetail.refundModal.alertPaymentDataNotFound'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 205) {
          alert(t('memberDetail.refundModal.alertAlreadyRefunded'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 206) {
          alert(t('memberDetail.refundModal.alertRefundExceeded'));
          setIsLoading(false);
          return;
        }
        else if (responseData.status === 401) history.push('/');
        else {
          alert(responseData.error);
          setIsLoading(false);
          return;
        }
      }
    )();
  }

  function onClickApprovalDate() {
  }

  function onChangeApprovalDate(data) {
    if (!isCenterRefund) {
      alert(t('memberDetail.refundModal.alertLinkpayDateFixed'));
      return;
    }

    setApprovalDate(data);
  }

  function onChangeSelectedPaymentOptions(data, index) {
    let newOptions = selectedPaymentOptions.slice();
    newOptions[index] = { ...newOptions[index], name: data.name, id: data.id };
    setSelectedPaymentOptions(newOptions);
  }

  function onChangePaymentOptionPrice(value, index) {
    let newOptions = selectedPaymentOptions.slice();
    let finalValue = value.replaceAll(',', '');
    if (finalValue !== '') newOptions[index].price = parseInt(finalValue).toLocaleString('ko-KR');
    else newOptions[index].price = finalValue;
    setSelectedPaymentOptions(newOptions);
  }

  function onClickAddPaymentOptions() {
    setSelectedPaymentOptions([...selectedPaymentOptions, { id: 0, name: '현금', price: 0 }]);
  }

  function onClickDeletePaymentOptions(index) {
    let newOptions = selectedPaymentOptions.slice();
    newOptions.splice(index, 1);
    setSelectedPaymentOptions(newOptions);
  }

  function onClickAdditionOption() {
    setIsClickedAddPaymentOption(true);
  }

  function onClickDeleteOption(paymentOptionId) {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/delete', 'POST', { paymentOptionId });
        if (responseData.status === 200) {
          setPaymentOptions([{ id: 0, name: '현금' }, { id: 0, name: '카드' }].concat(responseData.data.paymentOptions));
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }

  function onClickSavePaymentOption(optionName) {
    if (optionName === '') {
      alert(t('memberDetail.membershipEditModal.alertEnterPaymentName'));
      return;
    }
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('payment_option/save', 'POST', { optionName });
        if (responseData.status === 200) {
          setPaymentOptions([{ id: 0, name: '현금' }, { id: 0, name: '카드' }].concat(responseData.data.paymentOptions));
          setIsClickedAddPaymentOption(false);
        }
        else if (responseData.status === 401) history.push('/');
      }
    )();
  }

  return (
    <TotalModalWrapper>
      {
        isClickedAddPaymentOption &&
        <AddPaymentOptionModal
          onClickExit={() => setIsClickedAddPaymentOption(false)}
          onClickSave={onClickSavePaymentOption} />
      }
      {
        isLoading ?
          <ViewWrapper>
            <LottieWrapper>
              <Lottie animationData={LoadingAnimation} loop={true} />
            </LottieWrapper>
          </ViewWrapper>
          :
          <ModalTotalWrapper>
            {
              isViewSelectModal ?
                <SelectModalView $isDark={isDark}>
                  <RedTrashBoxWrapper>
                    <EmptyButtonWrapper />
                    <RedTrashBox>
                      <RefundImage src={RefundIcon} />
                    </RedTrashBox>
                    <EmptyButtonWrapper />
                  </RedTrashBoxWrapper>
                  <TotalWrapper>
                    <Title>{t('memberDetail.refundModal.linkopayRefundTitle')}</Title>
                    <SelectTextWrapper>
                      <Explanation>{t('memberDetail.refundModal.alreadySettledMembership')}</Explanation>
                      <Explanation>{t('memberDetail.refundModal.cardCancelNotProceed')}</Explanation>
                    </SelectTextWrapper>
                  </TotalWrapper>
                  <SelectButtonWrapper>
                    <NoButton onClick={() => setIsViewSelectModal(false)}>{t('memberDetail.modalClose')}</NoButton>
                    <YesButton onClick={onClickRefundOnCheckModal}>{t('memberDetail.refundModal.btnRefundAction')}</YesButton>
                  </SelectButtonWrapper>
                </SelectModalView>
                :
                <ModalViewWrapper isCenterRefund={isCenterRefund} $isDark={isDark}>
                  {
                    isCenterRefund ?
                      <ModalView>
                        <TotalView>
                          <TitleWrapper>
                            <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.text} cursor='default'>{t('memberDetail.refundModal.membershipRefundTitle').replace('{memberName}', memberName)}</Text>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('memberDetail.refundModal.refundIrreversibleDesc')}</Text>
                          </TitleWrapper>
                          <TotalMembershipInfoWrapper>
                            <MembershipInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.refundModal.membershipNameLabel')}</Text>
                              </InfoTextWrapper>
                              <InfoTextWrapper width={220}>
                                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{refundData.membershipName}</Text>
                              </InfoTextWrapper>
                            </MembershipInfoWrapper>
                            <MembershipInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.refundModal.paymentDate')}</Text>
                              </InfoTextWrapper>
                              <InfoTextWrapper width={220}>
                                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{moment(refundData.approvalDate).format(t('main.schedule.dateFormat'))}</Text>
                              </InfoTextWrapper>
                            </MembershipInfoWrapper>
                            <PaymentInfoWrapper>
                              <InfoTextWrapper width={105}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.refundModal.paymentAmount')}</Text>
                              </InfoTextWrapper>
                              <PaymentOptionsWrapper>
                                {
                                  refundData.selectedPaymentOptions && refundData.selectedPaymentOptions.length > 0 ?
                                    <PaymentDivisionBoxWrapper>
                                      <PaymentDivisionBox isCard={refundData.selectedPaymentOptions.length === 1 && (refundData.selectedPaymentOptions[0].name === '카드' || refundData.selectedPaymentOptions[0].name === '링코페이')}>
                                        <PaymentDivisionBoxTextWrapper>
                                          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='default'>
                                            {refundData.selectedPaymentOptions.length === 1 ? getPaymentName(refundData.selectedPaymentOptions[0].name) : t('memberDetail.payCombined')}
                                          </Text>
                                        </PaymentDivisionBoxTextWrapper>
                                      </PaymentDivisionBox>
                                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{refundData.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</Text>
                                    </PaymentDivisionBoxWrapper>
                                    : isLinkPayPaid ?
                                      <PaymentDivisionBoxWrapper>
                                        <PaymentDivisionBox isCard={true}>
                                          <PaymentDivisionBoxTextWrapper>
                                            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='default'>
                                              {getPaymentName('링코페이')}
                                            </Text>
                                          </PaymentDivisionBoxTextWrapper>
                                        </PaymentDivisionBox>
                                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{refundData.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</Text>
                                      </PaymentDivisionBoxWrapper>
                                    :
                                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.refundModal.payNone')}</Text>
                                }
                              </PaymentOptionsWrapper>
                              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.text} cursor='default'>{t('memberDetail.refundModal.won')}</Text>
                            </PaymentInfoWrapper>
                          </TotalMembershipInfoWrapper>
                          <TotalRefundInfoWrapper>
                            <RefundInfoWrapper>
                              <InfoTextWrapper width={191}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.refundModal.refundDate')}</Text>
                              </InfoTextWrapper>
                              <RefundInfoTextWrapper width={150}>
                                <CalenderInput width={150} value={approvalDate} setValue={onChangeApprovalDate} className='' clickFn={onClickApprovalDate} />
                              </RefundInfoTextWrapper>
                            </RefundInfoWrapper>
                          </TotalRefundInfoWrapper>
                          {
                            selectedPaymentOptions.map((data, index) => (
                              <PaymentLayerWrapper
                                key={`SelectedPaymentOptions-center-${index}`}
                                gap={20}
                                style={{ zIndex: selectedPaymentOptions.length - index }}>
                                <InputWrapper>
                                  <PaymentOptionTitleWrapper>
                                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{index === 0 ? t('memberDetail.refundModal.refundMethod') : (isEng ? t('memberDetail.refundModal.paymentMethod') : t('memberDetail.refundModal.refundMethod')) + ' ' + (index + 1)}</Text>
                                    {
                                      index !== 0 &&
                                      <DeleteButton onClick={() => onClickDeletePaymentOptions(index)}>
                                        <StyledTrashIcon />
                                      </DeleteButton>
                                    }
                                  </PaymentOptionTitleWrapper>
                                  {
                                    isLinkPayPaid && data.name !== '포인트' && data.name !== '현금' ?
                                      <LinkoPayTextView>
                                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.membershipEditModal.linkoPay')}</Text>
                                      </LinkoPayTextView>
                                      :
                                      <PaymentOptionSettingSelectBox
                                        index={index}
                                        value={data}
                                        setValue={onChangeSelectedPaymentOptions}
                                        options={paymentOptions}
                                        disabled={paymentOptions.length === 0}
                                        includeLinkoPayOption={true}
                                        isRefund={true}
                                        onClickAdditionOption={onClickAdditionOption}
                                        onClickDeleteOption={onClickDeleteOption} />
                                  }
                                </InputWrapper>
                                <RowDivisionLine />
                                <InputWrapper>
                                  <PaymentOptionTitleWrapper>
                                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.refundModal.refundAmount')}</Text>
                                  </PaymentOptionTitleWrapper>
                                  <UnitInputWrapper>
                                    <PaymentOptionCustomInput
                                      index={index}
                                      value={(data.price ?? 0).toLocaleString('ko-KR')}
                                      setValue={onChangePaymentOptionPrice}
                                      placeholder='0'
                                      textAlign='right' />
                                    <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.refundModal.won')}</Text>
                                  </UnitInputWrapper>
                                </InputWrapper>
                              </PaymentLayerWrapper>
                            ))
                          }
                          {
                            !isLinkPayPaid && selectedPaymentOptions.length < 2 &&
                            <AddPaymentOptionButtonWrapper>
                              <AddPaymentOptionButton onClick={onClickAddPaymentOptions}>{t('memberDetail.membershipEditModal.addPaymentOption')}</AddPaymentOptionButton>
                            </AddPaymentOptionButtonWrapper>
                          }
                          <ReasonInfoWrapper>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.refundModal.refundReason')}</Text>
                            <RefundReasonInput value={reason} setValue={setReason} placeholder={t('memberDetail.refundModal.refundReasonPlaceholder')} />
                          </ReasonInfoWrapper>
                          <CenterTextWrapper>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{isEng ? t('memberDetail.refundModal.totalPrefix') : storeName + '에서 ' + t('memberDetail.refundModal.totalPrefix')}</Text>
                            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.pointRed} style={{ marginLeft: `4px` }}>{selectedPaymentOptions.reduce((sum, opt) => sum + (parseInt(String(opt.price).replaceAll(',', '')) || 0), 0).toLocaleString('ko-KR')}{t('memberDetail.refundModal.wonSuffix')}</Text>
                            {isEng && <FlexBreak />}
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{isEng ? t('memberDetail.refundModal.willBeRefunded') + ' by ' + storeName : t('memberDetail.refundModal.willBeRefunded')}</Text>
                          </CenterTextWrapper>
                          <ButtonWrapper>
                            <ExitButton onClick={exitClick}>{t('memberDetail.modalCancel')}</ExitButton>
                            <SaveButton onClick={onClickRefund}>{t('memberDetail.refundModal.btnDoRefund')}</SaveButton>
                          </ButtonWrapper>
                        </TotalView>
                      </ModalView>
                      :
                      <ModalView>
                        <LinkoPayTitleWrapper>
                          <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.subBackground} cursor='default'>{t('memberDetail.refundModal.membershipRefundTitle').replace('{memberName}', memberName)}</Text>
                          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subBackground} cursor='default'>{t('memberDetail.refundModal.refundIrreversibleDesc')}</Text>
                        </LinkoPayTitleWrapper>
                        <TotalView>
                          <TotalMembershipInfoWrapper>
                            <MembershipInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.refundModal.membershipNameLabel')}</Text>
                              </InfoTextWrapper>
                              <InfoTextWrapper width={220}>
                                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{refundData.membershipName}</Text>
                              </InfoTextWrapper>
                            </MembershipInfoWrapper>
                            <MembershipInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.refundModal.paymentDate')}</Text>
                              </InfoTextWrapper>
                              <InfoTextWrapper width={220}>
                                <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{moment(refundData.approvalDate).format(t('main.schedule.dateFormat'))}</Text>
                              </InfoTextWrapper>
                            </MembershipInfoWrapper>
                            <PaymentInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.refundModal.paymentAmount')}</Text>
                              </InfoTextWrapper>
                              <PaymentOptionsWrapper>
                                {
                                  refundData.selectedPaymentOptions && refundData.selectedPaymentOptions.length > 0 ?
                                    <PaymentDivisionBoxWrapper>
                                      <PaymentDivisionBox isCard={refundData.selectedPaymentOptions.length === 1 && (refundData.selectedPaymentOptions[0].name === '카드' || refundData.selectedPaymentOptions[0].name === '링코페이')}>
                                        <PaymentDivisionBoxTextWrapper>
                                          <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='default'>
                                            {refundData.selectedPaymentOptions.length === 1 ? getPaymentName(refundData.selectedPaymentOptions[0].name) : t('memberDetail.payCombined')}
                                          </Text>
                                        </PaymentDivisionBoxTextWrapper>
                                      </PaymentDivisionBox>
                                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{refundData.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</Text>
                                    </PaymentDivisionBoxWrapper>
                                    : isLinkPayPaid ?
                                      <PaymentDivisionBoxWrapper>
                                        <PaymentDivisionBox isCard={true}>
                                          <PaymentDivisionBoxTextWrapper>
                                            <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subBackground} cursor='default'>
                                              {getPaymentName('링코페이')}
                                            </Text>
                                          </PaymentDivisionBoxTextWrapper>
                                        </PaymentDivisionBox>
                                        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{refundData.totalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</Text>
                                      </PaymentDivisionBoxWrapper>
                                    :
                                    <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.refundModal.payNone')}</Text>
                                }
                              </PaymentOptionsWrapper>
                              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('memberDetail.refundModal.won')}</Text>
                            </PaymentInfoWrapper>
                          </TotalMembershipInfoWrapper>
                          <TotalRefundInfoWrapper>
                            <RefundInfoWrapper>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.refundModal.refundDate')}</Text>
                              </InfoTextWrapper>
                              <RefundInfoTextWrapper width={241}>
                                <CalenderInput width={241} value={approvalDate} setValue={onChangeApprovalDate} className='' clickFn={onClickApprovalDate} />
                              </RefundInfoTextWrapper>
                            </RefundInfoWrapper>
                            <RefundInfoWrapper style={{ marginTop: '20px'}}>
                              <InfoTextWrapper width={100}>
                                <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.membershipEditModal.linkoPay')}</Text>
                              </InfoTextWrapper>
                              <PriceInputRow>
                                {isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.refundModal.won')}</Text>}
                                <PaymentOptionCustomInput
                                  index={0}
                                  value={(selectedPaymentOptions[0]?.price ?? 0).toLocaleString('ko-KR')}
                                  setValue={onChangePaymentOptionPrice}
                                  placeholder='0'
                                  textAlign='right'
                                  isFlex />
                                {!isEng && <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} cursor='default'>{t('memberDetail.refundModal.won')}</Text>}
                              </PriceInputRow>
                            </RefundInfoWrapper>
                          </TotalRefundInfoWrapper>
                          <ReasonInfoWrapper style={{ marginTop: '30px' }}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} cursor='default'>{t('memberDetail.refundModal.refundReason')}</Text>
                            <RefundReasonInput value={reason} setValue={setReason} placeholder={t('memberDetail.refundModal.refundReasonPlaceholder')} />
                          </ReasonInfoWrapper>
                          <CenterTextWrapper>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{isEng ? t('memberDetail.refundModal.totalPrefix') : storeName + '에서 ' + t('memberDetail.refundModal.totalPrefix')}</Text>
                            <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.pointRed} style={{ marginLeft: `4px` }}>{selectedPaymentOptions.reduce((sum, opt) => sum + (parseInt(String(opt.price).replaceAll(',', '')) || 0), 0).toLocaleString('ko-KR')}{t('memberDetail.refundModal.wonSuffix')}</Text>
                            {isEng && <FlexBreak />}
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText}>{isEng ? t('memberDetail.refundModal.willBeRefunded') + ' by ' + storeName : t('memberDetail.refundModal.willBeRefunded')}</Text>
                          </CenterTextWrapper>
                          <ButtonWrapper>
                            <ExitButton onClick={exitClick}>{t('memberDetail.modalCancel')}</ExitButton>
                            <SaveButton onClick={onClickRefund}>{t('memberDetail.refundModal.btnDoRefund')}</SaveButton>
                          </ButtonWrapper>
                        </TotalView>
                      </ModalView>
                  }
                </ModalViewWrapper>
            }
          </ModalTotalWrapper>
      }
    </TotalModalWrapper>
  )
}

const ModalTotalWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;
`;

const ModalViewWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  // padding: 20px 0px;
  padding-bottom: 20px;

  width: 380px;

  border-radius: 10px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(0, 0, 0, 0.1)'};
  background-color: ${props => props.theme.subBackground};
`;

const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
`;

const TotalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 0 20px;

  box-sizing: border-box;
  width: 100%;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 20px;

  width: 100%;
`;

const LinkoPayTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 10px 20px 10px 20px;

  width: calc(100% - 40px);

  border-radius: 10px 10px 0px 0px;
  background-color: ${props => props.theme.subKey};
`;

const TotalMembershipInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding-bottom: 20px;
  margin-top: 36px;

  width: 100%;

  gap: 20px;

  border-bottom: 1px solid ${props => props.theme.line};
`;

const MembershipInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const InfoTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 21px;

  gap: 20px;

  overflow: hidden;
`;

const PaymentDivisionBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const PaymentDivisionBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 0px 5px;

  max-width: 100px;
  max-height: 20px;

  border-radius: 5px;

  background-color: ${props => props.isCard ? props.theme.subKey : props.theme.primary};
`;


const PaymentDivisionBoxTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;
  height: 100%;

  overflow: hidden;
`;


const PaymentInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 5px;
`;

const PaymentOptionsWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  gap: 8px;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const TotalRefundInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin-top: 14px;

  width: 100%;

  gap: 10px;
`;

const RefundInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
`;


const RefundInfoTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 32px;

  gap: 20px;

  overflow: hidden;
`;

const ReasonInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin-top: 10px;

  width: 100%;

  gap: 4px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 30px;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 72px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.text};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.subKey};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const FlexBreak = styled.div`
  flex-basis: 100%;
  height: 0;
`;

const CenterTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  justify-content: flex-end;
  align-items: center;

  width: 100%;

  margin-top: 13px;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start
`;

const ComponentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin-top: ${props => props.topMagin}px;

  width: 314px;
`;

const CalenderWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  margin-top: 21px;

  width: 315px;
`;

const RefundRuleButton = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: red;

  margin: 0 0 0 160px;

  &:hover {
    cursor: pointer;
  }
`;

const SelectModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  width: 354px;
  height: 200px;

  border-radius: 15px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(0, 0, 0, 0.1)'};
  background-color: ${props => props.theme.subBackground};
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 12px;

  width: 90.33%;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const SelectTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  justify-content: center;
  align-items: center;

  margin-top: 8px;
`;

const Explanation = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;
`;

const RedTrashBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0px 12px 0px 12px;
  margin-top: -43px;

  width: calc(100% - 24px);
`;

const RedTrashBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  min-width: 86px;
  max-width: 86px;
  width: 86px;

  min-height: 86px;
  max-height: 86px;
  height: 86px;

  border-radius: 86px;
  background-color: #FF3131;
`;

const RefundImage = styled.img`
  // margin-left: -10px;

  // width: 53px;
  // height: 53px;
  width: 60px;
  height: 60px;
`;

const EmptyButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 12px;
  height: 12px;
`;

const ExitButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 36px;

  width: 12px;
  height: 12px;

  &:hover {
    cursor: pointer;
  }
`;

const ExitImage = styled.img`
  width: 12px;
  height: 12px;
`;

const SelectButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 28px;

  width: 100%;
  height: 52px;

  overflow: hidden;

  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
`;

const NoButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  background-color: ${props => props.theme.line};

  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.subKey};
  }
`;

const YesButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 50%;
  height: 100%;

  background-color: ${props => props.theme.line};

  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: #FF3131;
  }
`;

const CompleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 100%;

  background-color: ${props => props.theme.line};

  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: #FFFFFF;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.subKey};
  }
`;

const ViewWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 40px;

  width: 180px;
  height: 240px;

  overflow: hidden;

  border-radius: 8px;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 160px;
  height: 160px;
`;

const LoadingTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 140px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const PaymentLayerWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin: 20px 0 10px 0;

  width: 100%;
  box-sizing: border-box;

  gap: ${props => props.gap}px;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 6px;

  width: 100%;
`;

const PaymentOptionTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const PriceInputRow = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;

  flex: 1;
`;

const UnitInputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;

  width: 100%;
`;

const RowDivisionLine = styled.div`
  width: 1px;
  height: 54px;

  background-color: ${props => props.theme.line};
`;

const LinkoPayTextView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0 10px;

  box-sizing: border-box;
  width: 100%;
  height: 32px;

  border: 1px solid ${props => props.theme.buttonFill};
  background-color: ${props => props.theme.buttonFill};
`;

const AddPaymentOptionButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const AddPaymentOptionButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin: 20px 0 10px 0;

  width: 100%;
  height: 40px;

  border-radius: 20px;
  background-color: ${props => props.theme.buttonFill};

  font-family: NotoSansKR-Bold;
  font-size: 14px;

  color: ${props => props.theme.line};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      color: ${props => props.theme.subBackground};
      background-color: ${props => props.theme.subKey};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 24px;
  height: 18px;

  border-radius: 2px;
  background-color: ${props => props.theme.pointRedAlpha50};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.pointRed};
    }
  }

  transition: all 0.3s ease-in-out;
`;

const StyledTrashIcon = styled(TrashIcon)`
  width: 14px;
  height: 14px;

  & path {
    fill: ${props => props.theme.subBackground};
  }
`;